import React, { useState } from 'react';

import {
  useDataProvider,
  useNotify,
  useRecordContext,
  useRefresh,
} from 'react-admin';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Button } from '@mui/material';
import { DashboardResources } from '@src/types';

import RefundRepairDialog from './RefundRepairDialog';

const REFUNDABLE_STATES = [
  'Repair Complete',
];

const RefundRepairAction = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();
  const dataProvider = useDataProvider();

  const [isDialogLoading, setIsDialogLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!record || !REFUNDABLE_STATES.includes(record.status)) {
    return null;
  }

  const handleDialogClose = () => setIsDialogOpen(false);
  const handleDialogOpen = () => setIsDialogOpen(true);
  const handleDialogRefund = async () => {
    try {
      setIsDialogLoading(true);

      await dataProvider.refund(DashboardResources.Repairs, {
        repairUuid: record.id,
      });

      notify('Repair refunded successfully.', { type: 'success' });
      refresh();
      setIsDialogOpen(false);
    } catch (error) {
      console.error(error);
      notify('Error refunding repair.', { type: 'error' });
    } finally {
      setIsDialogLoading(false);
    }
  };

  return (
    <>
      <Button
        onClick={handleDialogOpen}
        size="small"
        startIcon={<AttachMoneyIcon />}
        variant="text"
      >
        Refund Repair
      </Button>
      <RefundRepairDialog
        handleRefund={handleDialogRefund}
        handleClose={handleDialogClose}
        isLoading={isDialogLoading}
        open={isDialogOpen}
      />
    </>
  );
};

export default RefundRepairAction;